const ON_CALL_ACT_CODES = [
  '203',
  '19127',
  '19128',
  '19129',
  '19130',
  '19131',
  '19132',
  '19133',
  '19134',
  '19135',
  '19136',
  '19137',
  '19138',
  '19139',
  '19140',
  '19141',
  '19142',
  '19143',
  '19144',
  '19145',
  '19146',
  '19147',
  '19148',
  '19149',
  '19150',
  '19151',
  '19152',
  '19153',
  '19154',
  '19155',
  '19156',
  '19157',
  '19158',
  '19159',
  '19160',
  '19161',
  '19162',
  '19163',
  '19164',
  '19165',
  '19166',
  '19167',
  '19168',
  '19169',
  '19170',
  '19171',
  '19172',
  '19173',
  '19174',
  '19175',
  '19176',
  '19177',
  '19178',
  '19179',
  '19180',
  '19181',
  '19182',
  '19183',
  '19184',
  '19185',
  '19186',
  '19187',
  '19188',
  '19189',
  '19190',
  '19191',
  '19192',
  '19193',
  '19194',
  '19195',
  '19196',
  '19197',
  '19198',
  '19199',
  '19200',
  '19201',
  '19202',
  '19203',
  '19204',
  '19205',
  '19206',
  '19207',
  '19208',
  '19209',
  '19210',
  '19211',
  '19212',
  '19215',
  '19216',
  '19217',
  '19218',
  '19219',
  '19220',
  '19221',
  '19222',
  '19223',
  '19224',
  '19225',
  '19226',
  '19227',
  '19228',
  '19229',
  '19230',
  '19231',
  '19232',
  '19233',
  '19234',
  '19235',
  '19236',
  '19237',
  '19238',
  '19239',
  '19240',
  '19241',
  '19242',
  '19243',
  '19244',
  '19245',
  '19246',
  '19247',
  '19248',
  '19249',
  '19250',
  '19251',
  '19252',
  '19253',
  '19254',
  '19255',
  '19256',
  '19257',
  '19258',
  '19259',
  '19260',
  '19261',
  '19262',
  '19263',
  '19264',
  '19265',
  '19266',
  '19267',
  '19268',
  '19269',
  '19270',
  '19271',
  '19272',
  '19273',
  '19274',
  '19275',
  '19276',
  '19277',
  '19278',
  '19279',
  '19280',
  '19281',
  '19282',
  '19283',
  '19284',
  '19285',
  '19286',
  '19287',
  '19288',
  '19289',
  '19290',
  '19291',
  '19292',
  '19293',
  '19294',
  '19295',
  '19296',
  '19297',
  '19298',
  '19299',
  '19300',
  '19301',
  '19302',
  '19303',
  '19304',
  '19305',
  '19306',
  '19307',
  '19308',
  '19309',
  '19310',
  '19311',
  '19312',
  '19313',
  '19314',
  '19315',
  '19316',
  '19317',
  '19318',
  '19319',
  '19320',
  '19321',
  '19322',
  '19323',
  '19324',
  '19325',
  '19326',
  '19327',
  '19328',
  '19329',
  '19330',
  '19331',
  '19332',
  '19333',
  '19334',
  '19335',
  '19336',
  '19337',
  '19338',
  '19343',
  '19344',
  '19345',
  '19346',
  '19347',
  '19348',
  '19349',
  '19350',
  '19351',
  '19352',
  '19353',
  '19354',
  '19355',
  '19356',
  '19357',
  '19358',
  '19359',
  '19360',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19363',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19364',
  '19365',
  '19366',
  '19367',
  '19368',
  '19405',
  '19406',
  '19407',
  '19408',
  '19409',
  '19410',
  '19411',
  '19412',
  '19413',
  '19414',
  '19415',
  '19416',
  '19417',
  '19418',
  '19419',
  '19420',
  '19421',
  '19422',
  '19423',
  '19424',
  '19425',
  '19426',
  '19427',
  '19428',
  '19429',
  '19430',
  '19431',
  '19432',
  '19433',
  '19434',
  '19435',
  '19436',
  '19479',
  '19480',
  '19481',
  '19482',
  '19483',
  '19484',
  '19485',
  '19486',
  '19487',
  '19488',
  '19489',
  '19490',
  '19491',
  '19492',
  '19493',
  '19494',
  '19495',
  '19496',
  '19497',
  '19498',
  '19499',
  '19500',
  '19501',
  '19502',
  '19503',
  '19504',
  '19505',
  '19506',
  '19507',
  '19508',
  '19509',
  '19510',
  '19511',
  '19512',
  '19513',
  '19514',
  '19515',
  '19516',
  '19517',
  '19518',
  '19519',
  '19520',
  '19521',
  '19522',
  '19523',
  '19524',
  '19525',
  '19526',
  '19527',
  '19528',
  '19529',
  '19530',
  '19531',
  '19532',
  '19533',
  '19534',
  '19535',
  '19536',
  '19538',
  '19539',
  '19540',
  '19541',
  '19542',
  '19543',
  '19544',
  '19545',
  '19546',
  '19547',
  '19548',
  '19549',
  '19550',
  '19551',
  '19552',
  '19553',
  '19554',
  '19555',
  '19556',
  '19557',
  '19558',
  '19559',
  '19560',
  '19561',
  '19562',
  '19563',
  '19564',
  '19565',
  '19566',
  '19567',
  '19568',
  '19569',
  '19570',
  '19571',
  '19572',
  '19573',
  '19574',
  '19575',
  '19576',
  '19577',
  '19578',
  '19579',
  '19580',
  '19581',
  '19582',
  '19583',
  '19584',
  '19585',
  '19586',
  '19587',
  '19588',
  '19589',
  '19590',
  '19591',
  '19594',
  '19595',
  '19596',
  '19597',
  '19598',
  '19599',
  '19600',
  '19601',
  '19602',
  '19603',
  '19604',
  '19605',
  '19606',
  '19607',
  '19608',
  '19609',
  '19610',
  '19611',
  '19612',
  '19613',
  '19637',
  '19638',
  '19639',
  '19640',
  '19656',
  '19657',
  '19658',
  '19659',
  '19777',
  '19778',
  '19779',
  '19780',
  '19781',
  '19782',
  '19800',
  '19801',
  '19802',
  '19803',
  '19804',
  '19805',
  '19806',
  '19807',
  '19808',
  '19809',
  '19810',
  '19811',
  '19812',
  '19813',
  '19814',
  '19815',
  '19818',
  '19819',
  '19820',
  '19821',
  '19831',
  '19832',
  '19861',
  '19862',
  '19863',
  '19864',
  '19865',
  '19866',
  '19867',
  '19868',
  '19889',
  '19890',
  '19891',
  '19892',
  '19906',
  '19907',
  '19932',
  '19933',
  '19934',
  '19935',
  '19936',
  '19937',
  '19938',
  '19939',
  '19940',
  '19941',
  '19942',
  '19943',
  '19944',
  '19945',
  '19946',
  '19947',
  '42000',
  '42001',
  '42002',
  '42003',
  '42004',
  '42005',
  '42006',
  '42007',
  '42008',
  '42009',
  '42010',
  '42011',
  '42012',
  '42013',
  '42014',
  '42015',
  '42016',
  '42017',
  '42018',
  '42019',
  '42020',
  '42021',
  '42022',
  '42023',
  '42024',
  '42025',
  '42026',
  '42027',
  '42028',
  '42029',
  '42030',
  '42031',
  '42032',
  '42033',
  '42034',
  '42035',
  '42036',
  '42037',
  '42040',
  '42041',
  '42042',
  '42043',
  '42044',
  '42045',
  '42046',
  '42047',
  '42140',
  '42141',
  '42142',
  '42143',
  '42146',
  '42147',
  '42154',
  '42155',
  '42156',
  '42157',
  '42179',
  '42180'
];

export default ON_CALL_ACT_CODES;
